import { useTranslation } from 'react-i18next';

import { CaseStatusType } from '~/common/enums';
import { type RecentCase } from '@/types/cases';

import { localStorageKeys } from '@/shared/utils/constants';
import ROUTES from '../../App/Router/Routes';
import { useGetCasesCount } from '@/queries';

import { CaseIcon } from '@/shared/icons/Icons';
import RecentSidebarContent from './RecentSideBarContent';

const CaseSidebarContent: React.FC = () => {
  const { t } = useTranslation();
  const { totalCases: pendingCasesCount } = useGetCasesCount(CaseStatusType.Pending);

  return (
    <RecentSidebarContent<RecentCase>
      storageKey={localStorageKeys.recentCases}
      title={t('case_other')}
      icon={<CaseIcon />}
      mainRoute={ROUTES.CASE_OVERVIEW}
      getItemRoute={(c) => `/case/${c.id}`}
      getItemTitle={(c) => c.reference}
      getItemTooltip={(c) => c.description}
      badgeContent={pendingCasesCount}
    />
  );
};

export default CaseSidebarContent;
